module.exports = __webpack_public_path__ + "static/media/rotaryDraw_bg3.846e2d19.png";